<template>
  <div :style="( search == true) ? 'background-color : white':''">
    <v-select
      label="dd_o_label"
      :reduce="options => options.dd_o_value"
      :options="options"
      v-model="post"
      @input="send"
    >
      <template #search="{attributes, events}" v-if="required == true">
        <input class="vs__search" :required="!post" v-bind="attributes" v-on="events" />
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: ["name", "validation", "content", "dropdown_name", "search", "disable_option", "table_module"],
  data() {
    return {
      post: this.content,
      options: [],
    };
  },
  mounted() {
    this.axios
      .get("/dropdown/list/" + this.dropdown_name)
      .then((response) => {
        let data = response.data.data;
        this.options = data
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 500) {
            console.log("error 500");
          }
        }
      });
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    options_com() {
      var that = this;
      let data = that.options;
      if (this.table_module == 'services') 
      {
        this.disable_option.forEach(element => {
          let id = element.crs_brand_id;
          let find = data.findIndex(
            (r) => r["dd_o_value"] == id
          );

          if (find > -1) 
          {
          //   delete data[find];              
            data.splice(find, 1) 
          }
        });  
      }
      return data
    }
  },
  methods: {
    send() {
      if (this.search == true) {
        let find = this.options.findIndex(
          (r) => r["dd_o_value"] == this.post
        );

        if (find >= 0) {
          this.$emit("post", {
            name: this.name,
            value: this.post,
            label: this.options[find]['dd_o_label'],
            type : 'option'
          });
        }

      } else {
        this.$emit("post", {
          name: this.name,
          value: this.post,
        });
      }
    },
  },
};
</script>